export default "__VITE_ASSET__CedhW6uq__"